module.exports = __webpack_public_path__ + "static/media/fire1.7e6b60d3.svg";